import { jsx as e } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 15.75V21.75L4.5 21.75C3.25736 21.75 2.25 20.7426 2.25 19.5V15.75H14.25ZM15.75 15.75V21.75H19.5C20.7426 21.75 21.75 20.7426 21.75 19.5V15.75H15.75ZM21.75 14.25H15.75V2.25H19.5C20.7426 2.25 21.75 3.25736 21.75 4.5L21.75 14.25ZM14.25 14.25H2.25V4.5C2.25 3.25736 3.25736 2.25 4.5 2.25H14.25V14.25Z",
    fill: "currentColor"
  }
);
export {
  r as default
};
